import React from "react";

import { Table as BaseTable } from "../atoms";
import { CellTextContentData } from "../cell-variants";

import { ContentRow } from "./content-row";
import { Header, HeaderProps } from "./header.tsx";
import { SectionHeader } from "./section-header";
import { getColumnCount } from "./util.ts";

export type TableProps = {
    sections: TableSectionsData;
    header: HeaderProps;
};

export type TableSectionsData = Array<{
    title: string;
    rows: CellTextContentData[][];
}>;

export const Table = (props: TableProps) => {
    const { sections, header } = props;

    const columnCount = getColumnCount(sections);

    return (
        <BaseTable>
            <Header {...header} />
            <tbody>
                {sections.map((section, sectionIndex) => {
                    return (
                        <React.Fragment key={sectionIndex}>
                            <SectionHeader
                                sectionTitle={section.title}
                                totalColumnCount={columnCount}
                            />
                            {section.rows.map((row, rowIndex) => (
                                <ContentRow
                                    key={`${sectionIndex}-${rowIndex}`}
                                    row={row}
                                    rowKey={`${sectionIndex}-${rowIndex}`}
                                    columnTitles={header.titles}
                                />
                            ))}
                        </React.Fragment>
                    );
                })}
            </tbody>
        </BaseTable>
    );
};
